import { Box, Button, Grid, List, ListItem, Typography } from "@mui/material";
import teacher from "../../assets/images/teacher-and-web-page.png";
import SubHeaderTwo from "../../app/layout/SubHeaderTwo";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import agent from "../../app/api/agent";

const Welcome = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const data = await agent.Account.currentUser();
      if (data.welcomeComplete === true) navigate("/myprogresssummary");
    };
    fetchData();
  }, []);

  const handleClick = () => {
    navigate("/welcome/cdabook");
  };

  return (
    <Box>
      <SubHeaderTwo />
      <Grid container>
        <Grid item xs={12} md={6}>
          <img
            src={teacher}
            alt="teacher and web page"
            style={{
              maxWidth: "100%",
              height: "auto",
            }}
          />
        </Grid>
        <Grid item xs={12} md={6} sx={{ pl: 4 }}>
          <Typography sx={{ ml: 2, fontWeight: "bold", lineHeight: 0.8 }}>
            With this portfolio you can:
          </Typography>
          <List sx={{ mb: 2 }}>
            <ListItem>
              <Typography>• Assemble your resource collection items</Typography>
            </ListItem>
            <ListItem>
              <Typography>• Complete each portfolio section</Typography>
            </ListItem>
            <ListItem>
              <Typography>• Upload required materials</Typography>
            </ListItem>
            <ListItem>
              <Typography>• Share your portfolio with others</Typography>
            </ListItem>
            <ListItem>
              <Typography>
                • Download and print a pdf of your entire portfolio
              </Typography>
            </ListItem>
          </List>
          <Button
            onClick={handleClick}
            variant="contained"
            sx={{ textTransform: "none", ml: 2, mb: 3 }}
          >
            Begin Steps
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Welcome;
